module.exports = __webpack_public_path__ + "img/email-send.883f50c3.svg";